import Button from 'ant-design-vue/es/button';
import './index.less';
import { computed, defineComponent, nextTick, ref, watch } from 'vue';
import { EditOutlined } from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import { Plugin } from '@vue/runtime-dom';
import { textProps } from 'ant-design-vue/es/typography/Text';
import { initDefaultProps } from 'ant-design-vue/es/_util/props-util';
import { Rule } from 'ant-design-vue/lib/form';

const jprops = {
  ...initDefaultProps(textProps(), {}),
  style: {
    type: Object as PropType<import('vue').CSSProperties>,
  },
};

const Rename = defineComponent({
  props: {
    ...jprops,
    value: { type: String, default: '', required: true },
    canEdit: { type: Boolean, default: true }, // 是否可编辑
    type: { type: String, default: 'modal' }, // 空间响应类型，modal | input
    title: { type: String, default: '重命名' }, // modal的标题
    maxlength: { type: Number, default: 20 }, // modal的标题
  },
  emits: ['update:value', 'change'],
  setup(props, ctx) {
    const data = ref('');
    const newData = ref('');
    const inEditStatus = ref(false);
    const formRef = ref(null); // 用于获取表单实例
    watch(
      () => props.value,
      () => {
        data.value = props.value;
      },
      {
        immediate: true,
      }
    );

    const meta = ref<any>({
      ...props,
      onChange: (newval) => {
        ctx.emit('update:value', newval); // 返回给调用者
        ctx.emit('change', newval);
      },
    });

    watch(props, async () => {
      meta.value = {
        ...props,
        onChange: (newval) => {
          // value.value = newval;
          ctx.emit('update:value', newval); // 返回给调用者
          ctx.emit('change', newval);
        },
      };
    });

    const dInput = ref();
    const dMinput = ref();

    const openModal = () => {
      inEditStatus.value = true;
      newData.value = data.value;
      focus();
    };

    const focus = () => {
      nextTick(() => {
        if (props.type === 'input') {
          dInput.value.focus();
        } else if (props.type === 'modal') {
          dMinput.value.focus();
        }
      });
    };

    const closeModal = () => {
      inEditStatus.value = false;
    };
    const handleConfirm = () => {
      inEditStatus.value = false;
      onOk();
    };
    // const rules = [
    //   { required: true, message: '请填写名称', trigger: 'blur' },
    //   { max: 20, message: '长度限制为20个字符', trigger: 'blur' },
    // ];
    const rules = ref<Record<string, Rule[]>>({
      // name: [{ required: true,validator, message: '内容不能为空', trigger: 'change' }],
    });

    const onblur = () => {
      if (props.type === 'input') {
        inEditStatus.value = false;
        onOk();
      }
    };

    const onOk = () => {
      if (newData.value === data.value) return;
      data.value = newData.value;
      meta.value.onChange(data.value);
    };

    return {
      data,
      newData,
      meta,
      inEditStatus,
      openModal,
      closeModal,
      handleConfirm,
      rules,
      formRef,
      onblur,
      dInput,
      dMinput,
    };
  },
  render() {
    return (
      <div>
        <div class="text">
          {(this.type !== 'input' || !this.inEditStatus) && (
            <span
              {...this.meta}
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              {this.data}
            </span>
          )}
          {this.type === 'input' && this.inEditStatus && (
            <a-input
              ref="dInput"
              v-model:value={this.newData}
              show-count={this.maxlength !== 0}
              maxlength={this.maxlength}
              style={{ borderColor: '#17A0E5', width: '100%' }}
              onblur={this.onblur}
            ></a-input>
          )}
          {this.canEdit && (
            <div class="icon-edit">
              <EditOutlined onClick={this.openModal} style={{ width: '16px', height: '16px' }} />
            </div>
          )}
        </div>

        {this.type === 'modal' && this.inEditStatus && (
          <Modal
            class="rename"
            v-model:open={this.inEditStatus}
            footer={null}
            closeable={false}
            centered={true}
          >
            <div class="top">
              <p style={{ fontSize: '16px', color: '#222222' }}>{this.title}</p>
            </div>

            <a-form rules={this.rules}>
              <a-form-item name="name">
                <a-input
                  ref="dMinput"
                  v-model:value={this.newData}
                  show-count={this.maxlength !== 0}
                  maxlength={this.maxlength}
                  style={{ margin: '32px 0px 7px 0px', borderColor: '#17A0E5' }}
                ></a-input>
              </a-form-item>
            </a-form>

            <div class="btn">
              <Button class="cancel" onClick={this.closeModal}>
                取消
              </Button>
              <Button class="confirm" type="primary" onClick={this.handleConfirm}>
                确定
              </Button>
            </div>
          </Modal>
        )}
      </div>
    );
  },
});

export const DRename: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DRename', Rename);
  },
};
